<template>
  <!-- Bootstrap Modal -->
  <div v-if="isVisible" class="modal fade show" :class="{ 'd-block': isVisible }" tabindex="-1" role="dialog"
    aria-hidden="false" @click.self="closeModal">

    <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
      <div class="modal-content">
        <!-- Header -->
        <div class="modal-header">
          <h3 class="modal-title">
            <i class="fe fe-code me-2"></i>
            CloudFormation Template - {{ sku }}
          </h3>
          <button type="button" class="btn-close me-1" @click="closeModal" aria-label="Close">
          </button>
        </div>

        <!-- Body -->
        <div class="modal-body">
          <!-- Error Message -->
          <div v-if="error" class="alert alert-danger mb-3">
            <i class="fe fe-alert-circle me-2"></i>
            {{ error }}
          </div>
          <!-- Template Content -->
          <div class="rounded">
            <div class="bg-light border-bottom p-3">
              <h5 class="mb-0">{{ templateFileName }}</h5>
            </div>
            <!-- Code Display Area -->
            <div class="code-display-wrapper">
              <div v-if="loading" class="loading-container">
                <div class="text-center">
                  <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  <p class="mt-3 mb-0 text-muted">Loading CloudFormation template...</p>
                </div>
              </div>
              <CodemirrorEditor v-else :editorId="`cfm-template-${sku}`" :modelValue="template" mode="yaml"
                :readOnly="true" :disabled="false" :refreshOn="false" :performLint="false" />
            </div>
          </div>
          <!-- Footer -->
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="downloadTemplate" :disabled="loading || !template">
              <i class="fe fe-download"> </i> Download
            </button>

            <button type="button" class="btn btn-outline-secondary" @click="closeModal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Bootstrap Modal Backdrop -->
  <div v-if="isVisible" class="modal-backdrop fade show">
  </div>
</template>

<script>
import CodemirrorEditor from './CodemirrorEditor.vue';
export default {
  name: 'CFMTemplateModal',
  components: {
    CodemirrorEditor
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    sku: {
      type: String,
      default: ''
    },
    template: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  computed: {
    isVisible() {
      return this.visible;
    },
    templateFileName() {
      return `${this.sku}-cloudformation.yaml`;
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    downloadTemplate() {
      const blob = new Blob([this.template], { type: 'text/yaml' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = this.templateFileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
  },
  emits: ['close']
};
</script>

<style scoped>
.code-display-wrapper {
  height: 400px;
  overflow: scroll;
}
</style>